
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index7GkCnYM5DGMeta } from "/home/user/aiboosted-website/pages/index.vue?macro=true";
import { default as _91id_93XwYIrFBw58Meta } from "/home/user/aiboosted-website/pages/resources/[id].vue?macro=true";
import { default as indexcOYGh5zRB5Meta } from "/home/user/aiboosted-website/pages/resources/index.vue?macro=true";
import { default as loginmH5baYsjZpMeta } from "/home/user/aiboosted-website/pages/resources/login.vue?macro=true";
import { default as resetPasswordtkr9zwSAqMMeta } from "/home/user/aiboosted-website/pages/resources/resetPassword.vue?macro=true";
import { default as signupHncfQnWJExMeta } from "/home/user/aiboosted-website/pages/resources/signup.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index7GkCnYM5DGMeta || {},
    component: () => import("/home/user/aiboosted-website/pages/index.vue")
  },
  {
    name: "resources-id",
    path: "/resources/:id()",
    meta: _91id_93XwYIrFBw58Meta || {},
    component: () => import("/home/user/aiboosted-website/pages/resources/[id].vue")
  },
  {
    name: "resources",
    path: "/resources",
    meta: indexcOYGh5zRB5Meta || {},
    component: () => import("/home/user/aiboosted-website/pages/resources/index.vue")
  },
  {
    name: "resources-login",
    path: "/resources/login",
    component: () => import("/home/user/aiboosted-website/pages/resources/login.vue")
  },
  {
    name: "resources-resetPassword",
    path: "/resources/resetPassword",
    component: () => import("/home/user/aiboosted-website/pages/resources/resetPassword.vue")
  },
  {
    name: "resources-signup",
    path: "/resources/signup",
    component: () => import("/home/user/aiboosted-website/pages/resources/signup.vue")
  }
]